document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.product__description');
  if (!container) return;

  const children = Array.from(container.childNodes);
  let currentSection = null;
  let currentTitle = null;
  let currentContent = null;
  let hasH2 = false;

  children.forEach(node => {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '') return;
    if (node.tagName === 'STYLE') return;

    if (node.tagName === 'H2') {
      hasH2 = true;
      currentSection = document.createElement('section');
      currentSection.className = 'toggle_content';

      currentTitle = document.createElement('h2');
      currentTitle.className = 'title_toggle';
      currentTitle.textContent = node.textContent;

      currentContent = document.createElement('div');
      currentContent.className = 'content_toggle';

      currentSection.appendChild(currentTitle);
      currentSection.appendChild(currentContent);
      container.insertBefore(currentSection, node);
      node.remove();
    } else if (currentSection && currentContent) {
      currentContent.appendChild(node.cloneNode(true));
      node.remove();
    } else if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
      currentSection = document.createElement('section');
      currentSection.className = 'normal_content';

      currentSection.textContent = node.textContent.trim();
      container.insertBefore(currentSection, node);
      node.remove();
    }
  });

  if (!hasH2) {
    const defaultSection = document.createElement('section');
    defaultSection.className = 'toggle_content';

    const defaultTitle = document.createElement('h2');
    defaultTitle.className = 'title_toggle';
    defaultTitle.textContent = 'Description';

    const defaultContent = document.createElement('div');
    defaultContent.className = 'content_toggle';

    defaultSection.appendChild(defaultTitle);
    defaultSection.appendChild(defaultContent);
    const remainingNodes = Array.from(container.childNodes);
    remainingNodes.forEach(node => {
      if (node !== defaultSection) {
        defaultContent.appendChild(node.cloneNode(true));
        node.remove();
      }
    });

    container.appendChild(defaultSection);
    defaultSection.classList.add('show');
  } else if (currentSection) {
    container.appendChild(currentSection);
  }

  // toggle custom
  const toggleTitles = document.querySelectorAll('.toggle_content h2');

  toggleTitles.forEach(title => {
    title.addEventListener('click', function () {
      const toggleContent = this.closest('.toggle_content');
      if (toggleContent) {
        toggleContent.classList.toggle('show');
      }
    });
  });

});


// get height element

function setActualHeightToCSSVar(selector = '.get_height') {
  const elements = document.querySelectorAll(selector);

  elements.forEach(el => {

    el.style.removeProperty('--data-height');

    const computed = window.getComputedStyle(el);
    const isVisible = computed.display !== 'none' &&
        computed.visibility !== 'hidden' &&
        computed.opacity !== '0' &&
        el.offsetHeight > 0;

    let height = 0;

    if (isVisible) {
      height = el.offsetHeight;
    } else {

      const clone = el.cloneNode(true);

      clone.style.cssText = `
                display: block !important;
                visibility: visible !important;
                position: absolute !important;
                top: -99999px !important;
                left: -99999px !important;
                height: auto !important;
                max-height: none !important;
                min-height: 0 !important;
                overflow: visible !important;
                opacity: 1 !important;
                width: ${el.offsetWidth > 0 ? el.offsetWidth + 'px' : 'auto'};
                padding: ${computed.paddingTop} ${computed.paddingRight} ${computed.paddingBottom} ${computed.paddingLeft};
                margin: 0 !important;
                border: ${computed.borderTopWidth} ${computed.borderTopStyle} ${computed.borderTopColor} 
                        ${computed.borderRightWidth} ${computed.borderRightStyle} ${computed.borderRightColor} 
                        ${computed.borderBottomWidth} ${computed.borderBottomStyle} ${computed.borderBottomColor} 
                        ${computed.borderLeftWidth} ${computed.borderLeftStyle} ${computed.borderLeftColor};
            `;

      document.body.appendChild(clone);
      height = clone.offsetHeight;
      document.body.removeChild(clone);
    }

    el.style.setProperty('--data-height', height + 'px');
  });
}

// auto run function get height when DOM change
(() => {
  const run = () => setActualHeightToCSSVar('.get_height');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  new MutationObserver((mutations) => {
    let shouldRun = false;
    for (const m of mutations) {
      if (m.type === 'childList') {
        const hasNew = [...m.addedNodes].some(node =>
            node.nodeType === 1 &&
            (node.matches('.get_height') || node.querySelector('.get_height'))
        );
        if (hasNew) shouldRun = true;
      }
      if ((m.type === 'childList' || m.type === 'characterData')) {
        const target = m.target;
        const parent = target.closest?.('.get_height') ||
            (target.nodeType === 1 && target.querySelector?.('.get_height'));
        if (parent) shouldRun = true;
      }
      if (shouldRun) break;
    }
    if (shouldRun) requestAnimationFrame(run);
  }).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // change when have img
  document.addEventListener('load', (e) => {
    if (e.target.tagName === 'IMG' && e.target.closest('.get_height')) {
      requestAnimationFrame(run);
    }
  }, true);

  // Resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 100);
  });
})();